exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sponsors{\r\n  display: block;\r\n  margin-top: 1em;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  text-align: center;\r\n}\r\n.clear{\r\n  clear: both;\r\n  margin-top: 5em;\r\n}\r\nh3{\r\n  font-size: 1.5em;\r\n  color: #31568c;\r\n  margin: 0;\r\n  letter-spacing: 0.125em;\r\n  font-weight: 600;\r\n  font-family: Georgia, serif;\r\n  padding: 1em .5em 1em .5em;\r\n  font-variant: small-caps;\r\n}\r\nimg{\r\n  height: 10em;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/sponsors/sponsors.component.css
// module id = ../../../../../src/app/sponsors/sponsors.component.css
// module chunks = main